import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "./navigation.css";

import logoImage from "../assets/img/tg3k-logo.png";
import JsonData from "../data/data.json";

export default function Navigation(props) {
  const [scrolled, setScrolled] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [formationsOpen, setFormationsOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navbarRef = useRef(null);

  const contactData = JsonData?.Contact || {};
  const email = contactData.email || "togo3000informatique@gmail.com";
  const phone = (contactData.phone || "+228 90 12 34 56").split(",")[0].trim();
  const address = contactData.address || "Lomé, Togo";

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    const handleClickOutside = (event) => {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        setDropdownOpen(false);
        setFormationsOpen(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleDropdownToggle = (e) => {
    e.preventDefault();
    setDropdownOpen(!dropdownOpen);
    setFormationsOpen(false);
  };

  const handleFormationsToggle = (e) => {
    e.preventDefault();
    setFormationsOpen(!formationsOpen);
    setDropdownOpen(false);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
    setDropdownOpen(false);
    setFormationsOpen(false);
  };

  const scrollToSection = (id, e) => {
    e.preventDefault();
    const element = document.querySelector(id);
    if (element) {
      const offsetTop = element.offsetTop;
      const navbarHeight = navbarRef.current ? navbarRef.current.offsetHeight : 0;

      window.scrollTo({
        top: offsetTop - navbarHeight,
        behavior: "smooth",
      });

      closeMobileMenu();
    }
  };

  return (
    <>
      <nav ref={navbarRef} className={`togo-navbar ${scrolled ? "scrolled" : ""}`}>
        <div className="container">
          <div className="togo-navbar-wrapper">
            <div className="togo-navbar-brand">
              <Link to="/header" className="togo-logo">
                <img
                  src={logoImage}
                  alt="Logo TOGO 3000 INFORMATIQUE"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/img/tg3k-logo.png";
                  }}
                />
                <div className="togo-brand-text">
                  <div className="togo-brand-name">
                    <span className="togo-red">TOGO 3000</span>
                    <span className="togo-blue">INFORMATIQUE</span>
                  </div>
                  <span className="togo-slogan">Un millénaire d'avance</span>
                </div>
              </Link>

              <div className="togo-navbar-contact-info">
                <a className="togo-contact-item" href={`mailto:${email}`}>
                  <i className="fa fa-envelope"></i>
                  <span>{email}</span>
                </a>
                <a className="togo-contact-item" href={`tel:${phone.replace(/\s+/g, "")}`}>
                  <i className="fa-solid fa-phone"></i>
                  <span>{phone}</span>
                </a>
                <div className="togo-contact-item location">
                  <i className="fa fa-map-marker"></i>
                  <span>{address}</span>
                </div>
              </div>
            </div>
            <button
              className={`togo-hamburger ${mobileMenuOpen ? 'active' : ''}`}
              onClick={toggleMobileMenu}
              aria-label="Toggle menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>


          <div className="togo-bottom-nav">

            <div className={`togo-bottom-nav-wrapper ${mobileMenuOpen ? 'mobile-open' : ''}`}>
              <ul className="togo-bottom-nav-tabs">

                <li className={`togo-bottom-nav-item togo-bottom-dropdown ${dropdownOpen ? "active" : ""}`}>
                  <div className="togo-dropdown-toggle-wrapper">
                    <div
                      className="togo-dropdown-toggle"
                      onClick={handleDropdownToggle}
                    >
                      <span>Togo 3000</span>
                    </div>
                    <button
                      className="togo-dropdown-expand-btn"
                      onClick={handleDropdownToggle}
                      aria-label="Toggle submenu"
                    >
                      {dropdownOpen ? '−' : '+'}
                    </button>
                  </div>
                  <div className="togo-bottom-dropdown-menu">
                    <Link to="/historique" onClick={closeMobileMenu}>
                      <i className="fa fa-clock"></i>
                      Historique
                    </Link>
                    <Link to="/presentation" onClick={closeMobileMenu}>
                      <i className="fa fa-users"></i>
                      Présentation & Organisation
                    </Link>
                    <Link to="/a-propos" onClick={closeMobileMenu}>
                      <i className="fa fa-info-circle"></i>
                      À propos
                    </Link>
                  </div>
                </li>

                {/* Onglet Produits */}
                {/* <li className="togo-bottom-nav-item">
                  <Link to="/produits" onClick={closeMobileMenu}>
                    <span>Produits</span>
                  </Link>
                </li> */}

                {/* Onglet Services */}
                <li className="togo-bottom-nav-item">
                  <Link to="/services" onClick={closeMobileMenu}>
                    <span>Services</span>
                  </Link>
                </li>

                {/* Onglet Formations avec dropdown */}
                {/* <li className={`togo-bottom-nav-item togo-bottom-dropdown ${formationsOpen ? "active" : ""}`}>
                  <div
                    className="togo-dropdown-toggle"
                    onClick={handleFormationsToggle}
                  >
                    <span>Formations</span>
                  </div>
                  <div className="togo-bottom-dropdown-menu">
                    <Link to="/modulaire" onClick={closeMobileMenu}>
                      <i className="fa fa-th-large"></i>
                      Formation Modulaire
                    </Link>
                    <Link to="/entreprise" onClick={closeMobileMenu}>
                      <i className="fa fa-briefcase"></i>
                      Formation Entreprise
                    </Link>
                  </div>
                </li>*/}

                {/* Onglet Équipe */}
                {/* <li className="togo-bottom-nav-item">
                  <Link to="/equipe" onClick={closeMobileMenu}>
                    <span>Équipe</span>
                  </Link>
                </li> */}

                {/* Onglet Références */}
                <li className="togo-bottom-nav-item">
                  <Link to="/references" onClick={closeMobileMenu}>
                    <span>Références</span>
                  </Link>
                </li>

                {/* Onglet Contact */}
                <li className="togo-bottom-nav-item">
                  <Link to="/contact" onClick={closeMobileMenu}>
                    <span>Contact</span>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}